import React from 'react';
import i18n from 'i18n-js';
import 'react-image-lightbox/style.css';
import { useStyles } from './Rating.styled';

const FormsRating = ({ rating, max = 5, comment }) => {
  const classes = useStyles();
  return (
    <>
      <p className={classes.item}>{i18n.t('forms.rate')}:</p>
      <span className={classes.value}>{`${rating}/${max}`}</span>

      {comment && (
        <>
          <p className={classes.item}>{i18n.t('forms.comments')}:</p>
          <span className={classes.value}>{comment}</span>
        </>
      )}
    </>
  );
};

export default FormsRating;
